import React from 'react';
import { useEffect, useState } from "react";
import axios from 'axios';

interface w7ResponseFormat {
    timeToStation: number
}

function BusTime() {

    const [w7Times, setW7Times] = useState<Array<number>>([]);
    const [previousw7Times, setpreviousw7Times] = useState<Array<number>>([]);
    const [currentTime, setCurrentTime] = useState<Date>(new Date());
    const [mostRecentUpdate, setMostRecentUpdate] = useState<Date>(new Date());
    const [isLoading, setLoading] = useState(true);
    const [err, setErr] = useState<Array<Number>>([]); 

    const formatSecondsAsMinutesAsSeconds = (timeInSeconds: number) => {
        return Math.floor(timeInSeconds/60).toString().toString() + " minutes, " + (timeInSeconds % 60).toString() + " seconds"
    }

    const listItems = w7Times.map(w7Time => <li key={w7Time}>{formatSecondsAsMinutesAsSeconds(w7Time)}. </li>);


    const submit = () => {
        setLoading(true)
        updateBusTimes()
    };

    const updateBusTimes = () => {
        axios
            .get('https://api.tfl.gov.uk/StopPoint/490008369CC/arrivals', {
            })
            .then((res) => {
                setpreviousw7Times(w7Times.slice())
                let newW7Times = res.data.map((fullJsonBlob: w7ResponseFormat) => fullJsonBlob.timeToStation)
                newW7Times.sort((t1: number, t2: number) => {return t1 - t2})

                console.log(JSON.stringify(newW7Times))
                console.log("fsdafds")
                console.log(JSON.stringify(w7Times))
                console.log("\n\n\n\n")

                setW7Times(prevW7Times => {
                    if (JSON.stringify(newW7Times) !== JSON.stringify(prevW7Times)) {
                        setMostRecentUpdate(new Date());
                    }
                    return newW7Times;
                });
                console.log(newW7Times)

                setLoading(false)
            })
            .catch((err) => {
                setErr(err.response.data.detail);
            });    
    }


    useEffect(() => {
        submit();

        const intervalId = setInterval(updateBusTimes, 4000);

        return () => {
          clearInterval(intervalId);
        };
    }, [])

    useEffect(() => {
        const interval = setInterval(() => 
        setCurrentTime(new Date()), 1000)

        return () => clearInterval(interval);
    }, []);

    return (
    <>  
        {isLoading && (
            <>
                Loading bus times.
            </>
        )}
        {!isLoading && (
            <>
                <br/>
                The next bus comes in {formatSecondsAsMinutesAsSeconds(w7Times[0])}.
                <br/>
                All bus times:
                <ul>
                    {listItems}
                </ul>
                The most recent update was received {Math.floor((currentTime.getTime() - mostRecentUpdate.getTime()) / 1000) } seconds ago. Updates occur roughly every 30 seconds.
            </>
        )}
        <br/>
        <button
                onClick={submit}
                className="submitButton"
        >
            Manually look for bus updates!
        </button>
        <br/><br/>
    </>
    );
}

export default BusTime;
